<template>
    <div :class="['input-wrapper', { 'input-error': hasError }]">
      <input :type="text"
              v-model="textValue"
              @input="onInput"
              @paste="onPaste"
              @keyup.enter="keyupHandler"
              :placeholder="placeholder"
              autocomplete="off" />
    </div>
</template>

<script setup>
  import { ref, watch } from 'vue'
  import { $T } from '@/utils/texts'

  const props = defineProps({
    modelValue: String,
  })

  const textValue = ref(props.modelValue)
  const hasError = ref(false)
  const placeholder = ref($T('file_request', 'input_placeholder'))
  const text = ref('')
  const emit = defineEmits(['update:modelValue', 'update:enter', 'update:input', 'update:paste'])

  watch(textValue, (newValue) => {
    emit('update:modelValue', newValue)
  })
  const onInput = () => {
    hasError.value = false
    emit('update:input', text.value)
  }

  const onPaste = () => {
    hasError.value = false
    emit('update:paste', text.value)
  }

  const keyupHandler = (event) => {
    if (event.key === 'Enter') {
      if (text.value === '' || hasError.value) {
        return
      }
      emit('update:enter', event)
    }
  }

  const getTextValue = () => textValue.value

  const setErrorState = (state) => {
    hasError.value = state
  }

  defineExpose({
    getTextValue,
    onInput,
    setErrorState,
  })
</script>

<style scoped>
  .input-wrapper {
    width: 280px;
    height: 30px;
    display: flex;
    align-items: center;
    background: #FFF;
    padding: 5px 10px;
    border: 1px solid #D8DADC;
    border-radius: 3px;
    box-sizing: border-box;
    &:hover {
      border-color: #C4C6C8;
    }
  }

  .input-wrapper.input-error {
    background-color: #FFF2F4;
    border-color: #FA899C;
    &:hover {
      border-color: #FA899C;
    }
  }

  .input-wrapper input {
    border: none;
    outline: none;
    padding: 4px;
    flex-grow: 1;
    background-color: transparent;
    &:hover {
      border-color: #C4C6C8;
    }
  }

  .input-wrapper input::placeholder {
    color: #BABCBE;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

</style>